export interface IBonusResumen {
  id: number;
  pcp_tin: string;
  location_name: string | null;
  anthem_earnings: string;
  emblem_earnings: string;
  anthem_potential: string;
  emblem_potential: string;
  total_earnings: string;
  total_potential: string;
}

export class BonusResumen implements IBonusResumen {
  id: number;
  pcp_tin: string;
  location_name: string | null;
  anthem_earnings: string;
  emblem_earnings: string;
  anthem_potential: string;
  emblem_potential: string;
  total_earnings: string;
  total_potential: string;

  constructor(data: IBonusResumen) {
    this.id = data.id;
    this.pcp_tin = data.pcp_tin;
    this.location_name = data.location_name;
    this.anthem_earnings = data.anthem_earnings;
    this.emblem_earnings = data.emblem_earnings;
    this.anthem_potential = data.anthem_potential;
    this.emblem_potential = data.emblem_potential;
    this.total_earnings = data.total_earnings;
    this.total_potential = data.total_potential;
  }

  static fromObject(data: IBonusResumen): BonusResumen {
    return new BonusResumen(data);
  }

  static fromObjectArray(data: IBonusResumen[]): BonusResumen[] {
    return data.map(BonusResumen.fromObject);
  }
}

export interface IResultBonusResumen {
  count: number;
  next: string | null;
  previous: string | null;
  results: IBonusResumen[];
}

export class ResultBonusResumen implements IResultBonusResumen {
  count: number;
  next: string | null;
  previous: string | null;
  results: BonusResumen[];

  constructor(data?: IResultBonusResumen) {
    this.count = data?.count ?? 0;
    this.next = data?.next ?? null;
    this.previous = data?.previous ?? null;
    this.results = data?.results ? BonusResumen.fromObjectArray(data.results) : [];
  }

  static fromObject(data: IResultBonusResumen): ResultBonusResumen {
    return new ResultBonusResumen(data);
  }
}
